// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterHeader_container__UyVcO","results":"FilterHeader_results__XO2ZZ","filters":"FilterHeader_filters__WhksS","title":"FilterHeader_title__anhBB"};